export const transition = { 
    duration: .25, 
    ease: [.56, .03, .12, 1.04]
};

export const variants = {
    initial: {
        opacity: 0
    },
    animate: {
        opacity: 1
    }
};

export const headerVariants = {
    initial: {
        opacity: 0,
        y: '.5rem'
    },
    animate: {
        opacity: 1,
        y: 0
    },
    exit: {
        opacity: 0,
        y: '-.5rem'
    }
}